import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import DashboardShell from "@/pages/DashboardShell";
import Overview from "@/pages/Overview";
import Listings from "@/pages/Listings";
import Deals from "@/pages/Deals";
import DealDetail from "@/pages/DealDetail";
import Payments from "@/pages/Payments";
import Invoices from "@/pages/Invoices";
import MandiSearch from "@/pages/MandiSearch";
import Rates from "@/pages/Rates";
import TradeRoute from "@/pages/TradeRoute";
import { BlogList, BlogArticle } from "@/pages/Blog";
import Notifications from "@/pages/Notifications";
import { AdminUsers, AdminDeals, AdminKyc } from "@/pages/Admin";
import Kyc from "@/pages/Kyc";

function Guard({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-stone-500">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AdminGuard({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-stone-500">Loading…</div>;
  if (user === false || user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/trade" element={<TradeRoute />} />

            <Route path="/app" element={<Guard><DashboardShell /></Guard>}>
              <Route index element={<Overview />} />
              <Route path="listings" element={<Listings />} />
              <Route path="deals" element={<Deals />} />
              <Route path="deals/:id" element={<DealDetail />} />
              <Route path="payments" element={<Payments />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="mandis" element={<MandiSearch />} />
              <Route path="rates" element={<Rates />} />
              <Route path="kyc" element={<Kyc />} />
              <Route path="blog" element={<BlogList />} />
              <Route path="blog/:slug" element={<BlogArticle />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="admin/users" element={<AdminGuard><AdminUsers /></AdminGuard>} />
              <Route path="admin/deals" element={<AdminGuard><AdminDeals /></AdminGuard>} />
              <Route path="admin/kyc" element={<AdminGuard><AdminKyc /></AdminGuard>} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
